export const DASHBOARD_ANALYTICS_REQUEST = 'DASHBOARD_ANALYTICS_REQUEST';
export const DASHBOARD_ANALYTICS_SUCCESS = 'DASHBOARD_ANALYTICS_SUCCESS';
export const DASHBOARD_ANALYTICS_FAIL = 'DASHBOARD_ANALYTICS_FAIL';